import { Component, OnInit } from "@angular/core";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { TableColumn } from "@swimlane/ngx-datatable";
import autoTable, { MarginPaddingInput, RowInput, Styles, UserOptions } from "jspdf-autotable";

@Component({
  template: `<p>PdfComponent works!</p>`
})
export class PdfComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  createCanvasFromElement(elementId: string) {
    let element: any = document.getElementById(elementId);

    return html2canvas(element, {
      onclone: function (clonedDoc) {
        // make the element visible for the pdf
        clonedDoc.getElementById(elementId).style.display = "flex";
      },
    });
  }

  addCanvasToPdf(canvas: HTMLCanvasElement, PDF: jsPDF, position: number) {
    let fileWidth = 208;
    let fileHeight = (canvas.height * fileWidth) / canvas.width;

    const FILEURI = canvas.toDataURL("image/png");
    PDF.addImage(FILEURI, "PNG", 0, position, fileWidth, fileHeight);
  }

  setTableOptions(
    PDF: jsPDF,
    startY: number,
    columns: TableColumn[],
    values: RowInput[],
    columnStyles: { [key: string]: Partial<Styles> } = null,
    hasHeader: boolean = false,
    hasFooter: boolean = false,
    // headStyles: { [key: string]: Partial<Styles> } = null
  ): UserOptions {
    return {
      head: [columns.map((x) => x.name)],
      body: values,
      theme: "plain",
      startY: startY,
      margin: {
        top: hasHeader ? 50 : 10,
        bottom: hasFooter ? 30 : 5,
        left: 14,//2.5,
        right: 14,//3.75,
      },
      styles: {
        fontSize: 8,
      },
      columnStyles: columnStyles,
      //   headStyles: headStyles,
      pageBreak: 'avoid',
      willDrawCell: (data) => {
        PDF.setDrawColor("#cccccc");
        PDF.setLineWidth(0.2);
        PDF.line(
          data.cell.x,
          data.cell.y + data.cell.height,
          data.cell.x + data.cell.width,
          data.cell.y + data.cell.height
        );
      },
      tableLineColor: "black",
      tableLineWidth: 0, //0.2
      didParseCell: (data) => {
        if (columnStyles && data.cell && data.cell.section === "head") {
          var colIndex = columns.findIndex((x) => x.name == data.cell.raw);

          //set header styles to match the column styles here
          if (columnStyles[colIndex]) {
            data.cell.styles.halign = columnStyles[colIndex].halign;
            data.cell.styles.cellWidth = columnStyles[colIndex].cellWidth;
            // data.cell.styles.fontSize = columnStyles[colIndex].fontSize;
            // data.cell.styles.cellPadding = columnStyles[colIndex].cellPadding;
          }
        }
      },
    };
  }
  
  addTextToPdf(
    PDF: jsPDF,
    data: RowInput[],
    fontSize?: number,
    padding?: number,
    startY?: number,
    offset?: number,
    center?: boolean,
    tableMargin?: MarginPaddingInput,
    hasHeader: boolean = false,
    hasFooter: boolean = false,
  ) {
      var columns = [
          {name: ''},
      ];
      var options = this.setTableOptions(
          PDF,
          (startY ?? ((PDF as any).lastAutoTable.finalY || 15) + (offset ?? 5)),
          columns,
          data,
          null,
          hasHeader,
          hasFooter,
      );
      options.styles = {
          fontSize: fontSize ?? 9,
          cellPadding: padding ?? 0.5,
          halign: center == true ? 'center' : 'left',
      };
      options.willDrawCell = (data) => {
          PDF.setDrawColor("#ffffff");
          PDF.setLineWidth(0);
          PDF.line(0,0,0,0);
      };
      if(tableMargin != null)
        options.margin = tableMargin;
      autoTable(PDF, options);
  }

  getBlankCellHook(PDF) {
      return (data) => {
          PDF.setDrawColor("#ffffff");
          PDF.setLineWidth(0);
          PDF.line(0,0,0,0);
      };
  }
}
